import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { default as styles } from './Navigation.module.scss';
import '@assets/image/fontawesome-free-6.0.0-web/css/all.min.css';
import { shopConfig } from '@/config/shop-config';

const staffRoute = [
  {
    to: '/bill',
    text: 'TẠO ĐƠN',
  },
  {
    to: '/list',
    text: 'DANH SÁCH ĐƠN',
  },
  {
    to: '/expense',
    text: 'CHI',
  },
  {
    to: '/note',
    text: 'GHI CHÚ',
  },
  {
    to: '/stock',
    text: 'KHO HÀNG',
  },
];
const staffRouteUser = [
  {
    to: '/my-account',
    text: 'Thông tin tài khoản',
  },
  {
    to: '/sign-out',
    text: 'Đăng xuất',
  },
];

const staffRouteSP = [
  {
    to: '/list',
    text: 'DANH SÁCH ĐƠN',
  },
  {
    to: '/expense',
    text: 'CHI',
  },
  {
    to: '/my-account',
    text: 'THÔNG TIN TÀI KHOẢN',
  },
  {
    to: '/stock',
    text: 'KHO HÀNG',
  },
  {
    to: '/sign-out',
    text: 'ĐĂNG XUẤT',
  },
];

function Navigation({ user }) {
  const location = useLocation();
  const [hide, setHide] = useState(true);

  useEffect(() => {
    const callback = (e) => setHide(true);
    document.addEventListener('click', callback);
    return () => {
      if (document) {
        document.removeEventListener('click', callback);
      }
    };
  }, []);

  return (
    <div className="grid wide">
      <ul className={clsx(styles.nav, styles.hideOnPhone)}>
        <li>
          <Link to="/">
            <img className={styles.logo} src={shopConfig.images.logo} alt="Logo Quốc Tiến" />
          </Link>
        </li>

        {staffRoute.map(({ to, text }) => (
          <li key={to}>
            <Link
              className={clsx(styles.navBtn, {
                [styles.active]: location.pathname.startsWith(to),
              })}
              to={to}
            >
              {text}
            </Link>
          </li>
        ))}

        <li
          onClick={(e) => {
            e.stopPropagation();
            setHide(!hide);
          }}
        >
          <i className="fas fa-user" />
          <h3 className={styles.greeting}>
            Xin chào {user?.role.name.toLowerCase()} {user?.displayName}
          </h3>

          <ul
            className={clsx(styles.userOptions, {
              [styles.hide]: hide,
            })}
          >
            {staffRouteUser.map(({ to, actualTo, text }) => (
              <li className={styles.userOption} key={to}>
                <Link className={clsx(styles.userLink)} to={actualTo || to}>
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </li>
      </ul>

      {/* Phone interface */}
      <ul className={clsx(styles.nav, styles.showOnPhone)}>
        <li>
          <Link to="/">
            <img className={styles.logo} src={shopConfig.images.logo} alt="Logo Quốc Tiến" />
          </Link>
        </li>

        <div className={clsx(styles.btnWrapper)}>
          <i
            className="fa-solid fa-bars"
            onClick={(e) => {
              e.stopPropagation();
              setHide(!hide);
            }}
          ></i>

          <ul
            className={clsx(styles.btns, {
              [styles.hide]: hide,
            })}
          >
            {staffRouteSP.map(({ to, actualTo, text }) => (
              <li key={to}>
                <Link
                  className={clsx(styles.navBtn, {
                    [styles.active]: location.pathname.startsWith(to),
                  })}
                  to={actualTo || to}
                >
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </ul>
    </div>
  );
}

export default Navigation;
